/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useLazyQuery, gql } from '@apollo/client';

export const useUpdateInteracUserConsent = () => {

    // const variables = {
    //         "updateInteracUserConsentRequest": {
    //           "fromPage": null,
    //           "isExistingUser": null,
    //           "guestUserId": null,
    //           "registeredUserId": null
    //         }
    // }
    

    const UPDATE_INTERAC_USER_CONSENT = gql`
    query UpdateInteracUserConsent($updateInteracUserConsentRequest: UpdateInteracUserConsentRequest!) {
        updateInteracUserConsent(updateInteracUserConsentRequest: $updateInteracUserConsentRequest) {
            registeredUserId
            userConsentUpdated
        }
    }
    `;

    const [updateInteracUserConsent, userConsentRes] = useLazyQuery(UPDATE_INTERAC_USER_CONSENT);

    return {updateInteracUserConsent, userConsentRes};
 }
